
//**************************************
// メインビジュアル スライダー
//**************************************
$(".slick-item").slick({
  autoplaySpeed: 4000,
  speed: 2500,
  autoplay: false,
  fade: true,
  dots: false,
  arrows: false,
  pauseOnHover: false,
  pauseOnFocus: false,
  swipe: false,
  touchMove: false
});

//**************************************
// ProgressBar 設定
//**************************************
var progressOption = {
  strokeWidth: 2,
  easing: 'easeInOut',
  duration: 4200,
  color: '#fff',
  trailColor: 'transparent', // ✅ 修正済
  trailWidth: 2,
  svgStyle: null
};

var dots = [
  new ProgressBar.Circle('.dots #dots0', progressOption),
  new ProgressBar.Circle('.dots #dots1', progressOption),
  new ProgressBar.Circle('.dots #dots2', progressOption),
  new ProgressBar.Circle('.dots #dots3', progressOption)
];

//**************************************
// 初期アニメーション
//**************************************
setTimeout(function() {
  $('.p-top-mv').addClass('show');
  dots[0].animate(1.0); // 最初のプログレススタート
  $('#dots0').addClass('active');
  $('.thumnail-item').eq(0).addClass('is-active'); 

  setTimeout(function() {
    $('.p-top-mv').addClass('show2');
    setTimeout(function() {
      $('.slick-item').slick('slickSetOption', 'autoplay', true, true);
    }, 1000);
  }, 500);
}, 100);

//**************************************
// スライド切り替え時処理
//**************************************
$('.slick-item').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  $('.dots div').removeClass('active');
  $('.thumnail-item').removeClass('is-active'); // ← サムネイルのアクティブ解除

  // 全てのプログレスをリセット
  dots.forEach(function(dot) {
    dot.animate(0, { duration: 1800 });
  });

  // 次のスライドに対応するドットをアクティブ化
  $('#dots' + nextSlide).addClass('active');
  dots[nextSlide].animate(1.0);
  $('.thumnail-item').eq(nextSlide).addClass('is-active'); 
  
});

//**************************************
// ドットクリックでスライド切り替え
//**************************************
$('.dots div').on('click', function() {
  var $slide = $(this).attr('data-slide');
  $('.slick-item').slick('slickGoTo', $slide);

  // プログレス制御
  $('.dots div').removeClass('active');
  dots.forEach(function(dot) {
    dot.animate(0, { duration: 1800 });
  });
  $('#dots' + $slide).addClass('active');
  dots[$slide].animate(1.0);
});

//**************************************
// ハンバーガーメニュー内のアンカーリンク クリック時に閉じる
//**************************************
document.addEventListener('DOMContentLoaded', function() {
  var headerDrawer = document.querySelector('header-drawer');
  if (!headerDrawer) return;

  headerDrawer.querySelectorAll('a').forEach(function(link) {
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) === '#' || href.indexOf('/#') !== -1) {
      link.addEventListener('click', function() {
        var summaryEl = headerDrawer.querySelector('summary');
        if (typeof headerDrawer.closeMenuDrawer === 'function') {
          headerDrawer.closeMenuDrawer(new Event('click'), summaryEl);
          if (summaryEl) summaryEl.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });
});

// $(function() {
//   $(".slick-item").slick({
//     autoplay: false,
//     arrows: false,
//     asNavFor: ".thumbnail",
//   });
//   $(".thumnbnail").slick({
//     autoplay: false,
//     arrows: false,
//     slidesToShow: 3,
//     asNavFor: ".slick-item",
//     focusOnSelect: true,
//   });
// });

//**************************************
// 下からふわっとアニメーション
//**************************************
const targets = document.querySelectorAll('.js-inview');
const options = {
  root: null,
  rootMargin: window.innerWidth > 768 ? '-100px' : '0px',
  threshold: 0
};

const observer = new IntersectionObserver(intersect, options);

targets.forEach(target => {
  observer.observe(target);
});

function intersect(entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-show');
      observer.unobserve(entry.target);
    }
  });
}